import React, { useCallback, useContext, useEffect, useState } from 'react';

import { app, media } from 'context';
import { Layout, PillButton } from 'ds';
import { SERVICES_REQUEST_PATH } from 'routes';

import { WHY_CODI_PHRASES } from './homeV10Constants';
import Reveal from './Reveal';

const PHRASE_DISPLAY_MS = 3200;

type PhrasePhase = 'entering' | 'visible' | 'exiting';

const WhyCodiSection: React.FC = () => {
  const { isMobile } = useContext(media);
  const { contentPaddingX } = useContext(app);
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [phrasePhase, setPhrasePhase] = useState<PhrasePhase>('entering');

  const handlePhraseAnimationEnd = useCallback((e: React.AnimationEvent<HTMLSpanElement>) => {
    const name = e.animationName;
    if (name === 'HomeV10-whyPhraseOut') {
      setPhraseIndex(i => (i + 1) % WHY_CODI_PHRASES.length);
      setPhrasePhase('entering');
      return;
    }
    if (name === 'HomeV10-whyPhraseIn') {
      setPhrasePhase('visible');
    }
  }, []);

  useEffect(() => {
    if (phrasePhase !== 'visible') return undefined;
    const id = window.setTimeout(() => {
      setPhrasePhase('exiting');
    }, PHRASE_DISPLAY_MS);
    return () => window.clearTimeout(id);
  }, [phrasePhase]);

  const phrase = WHY_CODI_PHRASES[phraseIndex];

  return (
    <Layout color="blue-50" paddingY={isMobile ? 72 : 112} paddingX={contentPaddingX} width="100%">
      <Layout justify="center" flex width="100%">
        <Reveal className="HomeV10-whyReveal">
          <div className="HomeV10-whyCodiStack">
            <h2 className="HomeV10-whyHeadline">
              <span className="HomeV10-whyHeadline__lead">Your AI office assistant</span>
              <br />
              <span className={`HomeV10-whyPhrase HomeV10-whyPhrase--${phrasePhase}`}>
                <span className="HomeV10-whyPhraseInner" onAnimationEnd={handlePhraseAnimationEnd}>
                  <span className="HomeV10-whyHeadline__accent">{phrase}</span>
                </span>
              </span>
            </h2>
            <Layout flex justify="center" width="100%">
              <PillButton
                type="purpleGradient"
                size="lg"
                text="Get started"
                href={SERVICES_REQUEST_PATH}
                icon="rightArrow"
                iconPosition="right"
                hasShadow
              />
            </Layout>
          </div>
        </Reveal>
      </Layout>
    </Layout>
  );
};

export default WhyCodiSection;
